import React from 'react';

/**
 * Jelly by Enkor official wordmark.
 * Uses the official brand GIF; `mix-blend-mode: screen` automatically drops
 * the black background and keeps only the pink wordmark visible on any background.
 */
const LOGO_SRC =
  'https://customer-assets.emergentagent.com/job_jelly-vibes/artifacts/pcaay96h_LogoJelly_Color2_ParaRegistro.gif';

export default function JellyLogo({
  size = 'md',
  // legacy props kept for backward-compat (no longer used since image already has color/byline)
  color,
  showByline,
  bylineColor,
  className = '',
}) {
  const heightClass = {
    sm: 'h-12',
    md: 'h-20 md:h-24',
    lg: 'h-32 md:h-40',
    xl: 'h-44 md:h-56',
  }[size] || 'h-20';

  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src={LOGO_SRC}
        alt="Jelly by Enkor"
        className={`${heightClass} w-auto select-none pointer-events-none`}
        style={{
          mixBlendMode: 'screen',
          filter: 'hue-rotate(-30deg) saturate(6) brightness(1.15) contrast(1.25)',
        }}
        draggable="false"
      />
    </span>
  );
}
